import { useLearningModules } from 'src/shared/hooks/learningModules'
import { Container, HeaderContainer } from 'src/shared/styled/Module'
import { PageLevelHeading } from 'src/shared/styled/Text'
import LoadingScreen from 'src/shared/views/LoadingScreen'
import LearningModules from '../views/LearningModules'

const LearningModulesContainer = () => {
  const { learningModules, isLoading } = useLearningModules()

  return (
    <Container>
      <HeaderContainer>
        <PageLevelHeading>Learning Modules</PageLevelHeading>
      </HeaderContainer>
      {!learningModules || isLoading ? (
        <LoadingScreen />
      ) : (
        <LearningModules learningModules={learningModules} />
      )}
    </Container>
  )
}

export default LearningModulesContainer
